import AuthLayout from '@/layouts/AuthLayout';
import { Button } from '@/lib/base/buttons/button';

export function AccessPausedPage() {
  return (
    <AuthLayout title='Access paused'>
      <div className='flex flex-col gap-6' data-testid='access-paused-page'>
        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
            Access to this team is paused
          </h1>
          <p className='text-[var(--color-text-secondary)]'>
            An admin needs to reactivate your access. This typically happens
            when the team&apos;s seat plan is reduced. Reach out to your team
            admin to request reactivation.
          </p>
        </div>

        <div className='flex flex-col gap-3 sm:flex-row'>
          <Button color='primary' href='/account/logout'>
            Sign in to a different account
          </Button>
          <Button color='secondary' href='mailto:help@ahoy.ai'>
            Contact support
          </Button>
        </div>
      </div>
    </AuthLayout>
  );
}

export default AccessPausedPage;
